export const getSavingsCalculators = state => state.savingsCalculators;